/* Motion preference — a single source of truth for the footer "Reduce motion"
   toggle.  Persisted in localStorage so the choice survives across sessions. */
const KEY = "dt6_motion_pref";

/** Return "cinematic" | "static" | null (null → let the auto-detector decide). */
export function getMotionPref() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "cinematic" || v === "static" ? v : null;
  } catch (_e) {
    return null;
  }
}

export function setMotionPref(pref) {
  try {
    if (pref === null || pref === undefined) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
    // Notify other components in the same tab.
    window.dispatchEvent(new CustomEvent("dt6:motion-pref-change", { detail: pref }));
  } catch (_e) {
    /* no-op */
  }
}
